import { parseScreenResolution } from "./parseScreenResolution";
import { updateNestedAttributes } from "./updateNestedAttributes";

const isBoolean = value => typeof value === "boolean";
export const transformJS = (data, backData, attributesJS) => {
  const userAgentJs = backData["userAgent"];
  const userAgent = backData["userAgentJs"];

  const isEqualUserAgent = userAgentJs === userAgent;

  const attributesArray = [
    "locationBar",
    "menuBar",
    "personalBar",
    "statusBar",
    "toolBar",
    "buildID",
    "adblock",
    "hardware",
    "deviceMemory",
    "availableTop",
    "availableLeft",
    "availableHeight",
    "availableWidth",
    "webGLVendor",
    "webGLRenderer",
    "localStorageSupported",
    "sessionStorageSupported",
    "indexedDBSupported",
    "battery",
    "accelerometer",
    "gyroscope",
    "proximitySensor",
    "webGLParameters",
    "mediaDevices",
  ];
  const isExistAttributesJs = attribute => attributesArray.includes(attribute);

  // for nested attributes
  const nestedAttributesArray = [
    "permissions",
    "audioContext",
    "connection",
    "analyser",
    "videoFormats",
    "audioFormats",
  ];

  return data.map(item => {
    const ratio = item.ratio.toFixed(2);
    if (item.id === "userAgentJs") {
      return {
        ...item,
        value: userAgentJs,
        ratio: isEqualUserAgent ? ratio : "0.00",
      };
    }
    if (item.id === "screenWidth") {
      return {
        ...item,
        ratio,
        value: parseScreenResolution(backData?.screen, "width"),
      };
    }
    if (item.id === "screenHeight") {
      return {
        ...item,
        ratio,
        value: parseScreenResolution(backData?.screen, "height"),
      };
    }

    if (isExistAttributesJs(item.id)) {
      if (isBoolean(attributesJS[item.id])) {
        return { ...item, ratio, value: attributesJS[item.id] };
      }
      return {
        ...item,
        ratio,
        value: attributesJS[item.id] || item.value,
      };
    }

    // for nested attributes
    const updatedItem = updateNestedAttributes(
      item,
      nestedAttributesArray,
      attributesJS,
    );
    if (updatedItem !== item) {
      return updatedItem;
    }

    if (isBoolean(backData[item.id])) {
      return { ...item, ratio, value: backData[item.id] };
    }

    return {
      ...item,
      ratio,
      value: (item.id && backData[item.id]) || item.value,
    };
  });
};
